import { Injectable } from '@angular/core'
import {
  CalendarNativeDateFormatter,
  DateFormatterParams,
} from 'angular-calendar'

@Injectable()
export class CalendarHeaderFormatter extends CalendarNativeDateFormatter {
  public override monthViewColumnHeader({
    date,
    locale,
  }: DateFormatterParams): string {
    return new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date)
  }
}
